import {getAccessToken, getTenant} from "./jetms-interop"

const GetRdsPartners = () => {
  return fetch(window.env.api + '/applications/deliveryconfiguration/partnersubscriptions?serviceType=Rds&serviceType=restaurantbroker&serviceType=', {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken(),
      'Content-Type': 'application/json',
      'x-je-tenant': getTenant(),
    },
  })
}

export default { GetRdsPartners }



// WEBPACK FOOTER //
// ./src/api/partnersubscriptions.js